import { Draft } from '@reduxjs/toolkit';

import { ISettingsData } from '../../index';

function editFailure(draft: Draft<ISettingsData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
